export default "__VITE_ASSET__Da_4S22m__"